import type { ConfigLisResponse, CustomSignUpParams, DictListResponse, DictParams } from './interface'
import { useRequest, useRequestApi4, useRequestDirect } from '~/composables/useRequest'

const sameUrl = '/member-app'
const pcUrl = '/member-pc'
// 字典
export async function getOptionList(params: DictParams): DictListResponse {
  const url = `/option/option-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 区域下拉
export async function getAreaList(params: any) {
  const url = `/glb/area/list-simple`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 板块下拉
export async function getAreaChildList(params: any) {
  const url = `/glb/city-zone/list-simple`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// import { useRequest } from '~/composables/useRequest'

type Latitude = number
type Longitude = number
interface GetAddrParams {
  location: `${Latitude},${Longitude}`
}
// 逆地址解码
export function getAddr(params: GetAddrParams) {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.baiduApi}?ak=${runtimeConfig.public.mapKey}&output=json&coordtype=wgs84ll`
  return $fetch(`${url}`, {
    params,
  })
}

// 获取报名配置
export async function getSignUpConfig(params: { configCodes: string }): ConfigLisResponse {
  const url = `/customer/sign-up/get-config-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 客户报名
export function customSignUp(params: CustomSignUpParams): Promise<any> {
  const url = `/customer/sign-up/save`
  return useRequest().post(`${sameUrl}${url}`, params)
}

// 登录
export function login(params: any): Promise<any> {
  const url = `/users/mobile-sms-code-login`
  return useRequest().post(`${sameUrl}${url}`, params)
}

// 获取用户信息
export function getUserInfo(): Promise<any> {
  const url = `/users/get-user-info`
  return useRequest().get(`${sameUrl}${url}`)
}

// 城市列表
export async function getCityList() {
  const url = `/xiaoqu/glb/city/list-city/1`
  return useRequestApi4().get(`${url}`)
}

// String型配置参数
export async function stringValue(params) {
  const url = `/xiaoqu/glb/deploy/string-value`
  return useRequestApi4().get(`${url}`, params)
}

// 百度统计配置
export async function baiduKey(params) {
  const url = `/xiaoqu/glb/deploy/baidu`
  return useRequestApi4().get(`${url}`, params)
}

/**
 * 退出服务端登录状态
 */
export function logout() {
  const url = `https://member.fccs.com/regv2/logout.do`
  return useRequestDirect().get(`${url}`)
}

/**
 * 刷新token
 */
export function refreshToken() {
  const url = `/users/refresh-token`
  return useRequest().get(`${sameUrl}${url}`)
}
// 用户浏览埋点 => 埋点保存
export async function browseTrackingSave(params: any) {
  const url = `/user-browse-tracking/save`
  return useRequest().post(`${pcUrl}${url}`, params)
}
// 隐私号埋点 => 埋点保存
export async function secretNumberTrackingSave(params: any) {
  const url = `/user-secret-number-tracking/save`
  return useRequest().post(`${sameUrl}${url}`, params)
}
// 检查是否收藏（批量）
export async function userSaveFavoriteBatchCheck(params: any) {
  const url = `/users/favorite/batch-check`
  return useRequest().post(`${pcUrl}${url}`, params)
}
